<template>
    <v-dialog v-model="value" max-width="1000px" persistent>
        <template>
            <v-card color="primary" dark v-if="isLoadingEdit">
                <v-card-text>
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
            <v-container fluid class="px-0 py-4 addClientsModal"
                         style="background: #fff; position: relative; overflow: hidden;" v-else>
                <ValidationObserver ref="form" v-slot="{ validate, reset }">
                    <v-row>
                        <v-col cols="12" class="pb-0 pt-0">
                            <h4
                                    class="display-2 primary--text font-weight-bold text-center text-uppercase"
                            >PUSH NOTIFICATION </h4>
                            <v-row class="text-center" v-if="invoice">
                                <v-col cols="4" class="py-1">
                                    <span class="label mr-2">ID Campagne:</span> {{ invoice.invoiceNumber}}
                                </v-col>
                                <v-col cols="4" class="py-1">
                                    <span class="label mr-2">Date:</span> {{ invoice.createdAt | moment('DD/MM/YYYY') }}

                                </v-col>
                                <v-col cols="4" class="py-1">
                                    <span class="label mr-2">Client:</span> {{ invoice.client }}
                                </v-col>
                            </v-row>
                            <v-divider class="my-0"></v-divider>
                        </v-col>
                    </v-row>
                    <v-form class="px-6">
                        <v-row class="justify-center">
                            <v-col cols="3">
                                <p class="label">Image</p>
                                <ImagePickerInput @input="imageFile" :value="logoFile"></ImagePickerInput>
                            </v-col>
                            <v-col cols="4">
                                <v-card flat class="mt-0 mx-auto px-2">
                                    <v-card-text class="pa-0 mb-1">
                                        <v-row>
                                            <v-col style="white-space: nowrap;" class="pt-0 pb-2">
                                                <p class="label">Titre <span class="red--text text--lighten-1">*</span>
                                                </p>
                                                <ValidationProvider rules="required" v-slot="{ errors }">
                                                    <v-text-field
                                                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                            maxlength="100"
                                                            placeholder="100 caractères maximum"
                                                            hide-details="auto"
                                                            :error-messages="errors"
                                                            v-model="form.title"
                                                            outlined
                                                            required>
                                                    </v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-text class="pa-0">
                                        <p class="label">Message <span class="red--text text--lighten-1">*</span></p>
                                        <ValidationProvider rules="required" v-slot="{ errors }">
                                            <v-textarea
                                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                    maxlength="300"
                                                    outlined
                                                    placeholder="300 caractères maximum"
                                                    name="input-7-4"
                                                    v-model="form.body"
                                                    hide-details="auto"
                                                    :error-messages="errors"
                                                    class="pb-3"
                                                    value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                                            ></v-textarea>
                                        </ValidationProvider>
                                        <ValidationProvider v-if="pushBrowser == true" rules="required|url"
                                                            v-slot="{ errors }">
                                            <p class="label" v-if="pushBrowser == true">URL <span
                                                    class="red--text text--lighten-1">*</span></p>
                                            <v-text-field :error-messages="errors" class="pb-1"
                                                          v-if="pushBrowser == true" hide-details="auto"
                                                          v-model="form.link" outlined></v-text-field>
                                        </ValidationProvider>
                                        <ValidationProvider v-if="pushApp == true" rules="required" v-slot="{ errors }">
                                            <p class="label mt-2" v-if="pushApp == true">Contenu <span
                                                    class="red--text text--lighten-1">*</span></p>
                                            <ContentAppInput v-if="pushApp == true" :errors="errors"
                                                             v-model="form.notification"></ContentAppInput>
                                        </ValidationProvider>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <p class="label">Prévisualiser</p>
                                <v-card flat class="mt-0 mx-auto px-2" outlined>
                                    <v-row>
                                        <v-col cols="9">
                                            <p class="font-weight-bold mb-1">
                                                {{ form.title ? form.title : 'Titre'}}

                                            </p>
                                            <p style="white-space: pre-line; margin-bottom: 0">{{ form.body ? form.body
                                                : 'Message' }}</p>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-img v-if="logoUrlABC" :src="logoUrlABC" class="mt-5"></v-img>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                            <div class="col-12 text-center pt-0">
                                <v-btn
                                        class="ma-2 ml-0"
                                        depressed
                                        rounded
                                        color="primary"
                                        @click="push"
                                        :loading="isLoading"
                                >
                                    <span>Envoyer</span>
                                </v-btn>
                                <v-btn
                                        class="ma-2 black--text"
                                        depressed
                                        rounded
                                        color="#E1E1E1"
                                        @click="closeModal"
                                >Annuler
                                </v-btn>
                            </div>
                        </v-row>

                        <v-btn icon @click="closeModal" absolute top right class="headline"
                               style="margin-top: -12px;margin-right: -12px;">
                            <i class="fal fa-times"></i>
                        </v-btn>
                    </v-form>
                </ValidationObserver>
            </v-container>
        </template>
    </v-dialog>
</template>

<script>
  import NotificationService from "@/services/notification.service.js";
  import {ValidationObserver, ValidationProvider} from "vee-validate";
  import ImagePickerInput from "@/components/inputs/ImagePickerInput.vue";
  import ImageReaderUtil from '../../utils/image-reader.util';
  import ContentAppInput from "@/components/inputs/ContentAppInput.vue";

  export default {
    name: "PushNotificationForm",
    components: {
      ValidationObserver,
      ValidationProvider,
      ImagePickerInput,
      ContentAppInput
    },
    props: {
      value: {},
      id: {},
      invoice: {},
      siteId: {},
      pushApp: false,
      pushBrowser: false,
    },
    data: () => ({
      isLoadingEdit: false,
      isLoading: false,
      form: {
        title: "",
        body: "",
        link: "",
        icon: "",
        invoiceId: null,
        siteId: null
      },
      logoFile: null,
      logoUrlABC: null,
      detail: []
    }),
    async created() {
      this.form = NotificationService.getInitFormData();
    },
    methods: {
      async imageFile(event) {
        let form = JSON.parse(JSON.stringify(this.form));
        this.logoFile = event;
        this.logoUrlABC = await ImageReaderUtil.readAsDataURL(event);
        this.form = form;
      },
      async closeModal() {
        await this.$refs.form.reset();
        this.$emit("input", false);
        this.form = NotificationService.getInitFormData();
      },
      assignToForm(data) {
        this.form = Object.assign(this.form, data);
      },
      async push() {
        this.isLoading = true;

        const success = await this.$refs.form.validate();

        if (!success) {
          this.isLoading = false;
          return;
        }

        if (this.form.notification) {
          this.form.notificationId = this.form.notification.id;
          this.form.notificationName = this.form.notification.name;
          delete (this.form.notification);
        }

        try {
          if (this.logoFile) {
            const imageUpload = await NotificationService.upload(this.logoFile);
            this.form.icon = imageUpload.data.path;
          }

          this.isLoading = true;

          if (this.invoice) {
            // Push for invoiceId
            this.form.invoiceId = this.invoice.id;
            delete this.form.siteId;
            NotificationService.send(this.form);
          } else if (this.siteId) {
            // Push for siteId
            this.form.siteId = this.siteId;
            delete this.form.invoiceId;
            NotificationService.pushNoIdentity(this.form);
          } else {
            // Push for all none identity
            delete this.form.invoiceId;
            delete this.form.siteId;

            NotificationService.pushNoIdentity(this.form);
          }

          this.closeModal();
        }
        catch (e) {
          this.handleError(e);
        }

        this.isLoading = false;
      }
    },
    watch: {}
  };
</script>
